module.exports = __webpack_public_path__ + "65e0f9bc0d36d9612675f7943ffd92fe.png";